(function(){

    class SystemTotalBet extends PIXI.Container{
        constructor(){
            super();

			this.stakeController = undefined;
			this.stakeText = undefined;

			this.inPromotion = false;

			this.platformEnabled = false;
			this.platformVisible = false;

			messageBus.subscribe("spinner:GameConfigEvent", this.init.bind(this) );
			messageBus.subscribe("common:PromotionStarted", this.onPromotionStarted.bind(this));
			messageBus.subscribe("common:PromotionEnded", this.onPromotionEnded.bind(this));
        }
       
        initialise() {
        };

		init( configEvent ) {
			let promotionActive = configEvent.data.slotConfig.promotionActive;
			if ((promotionActive !== null) && (promotionActive !== undefined)) {
				this.inPromotion = promotionActive;
			}			

			this.stakePreviousButton = resourceManager.get("systemSettings:systemSettingsBox:systemTotalBet:totalBetMinusButton");
			this.stakePreviousButton.onPressedCallback = this.onStakePreviousPressed.bind(this);

			this.stakeNextButton = resourceManager.get("systemSettings:systemSettingsBox:systemTotalBet:totalBetPlusButton");
			this.stakeNextButton.onPressedCallback = this.onStakeNextPressed.bind(this);

			this.stakeText = resourceManager.get("systemSettings:systemSettingsBox:systemTotalBet:stakeAmount");

	   		this.platformEnabled = configEvent.data.uiElements.btnUpstake.enabled;
			this.platformVisible = configEvent.data.uiElements.btnUpstake.visible;
    
			// this.luckyBetOnButton = resourceManager.get("systemSettings:systemSettingsBox:systemTotalBet:luckyBetOn");
			// this.luckyBetOnButton.mousedown = this.luckyBetOnButton.touchstart = this.luckyBetOnPressed.bind(this);

			// this.luckyBetOffButton = resourceManager.get("systemSettings:systemSettingsBox:systemTotalBet:luckyBetOff");
			// this.luckyBetOffButton.mousedown = this.luckyBetOffButton.touchstart = this.luckyBetOffPressed.bind(this);

			// this.luckyBetOnButton.interactive = false && this.platformEnabled;
			// this.luckyBetOffButton.interactive = true && this.platformEnabled;

			// this.luckyBetOnButton.visible = false && this.platformVisible;
			// this.luckyBetOffButton.visible = true && this.platformVisible;

			this.stakeController = resourceManager.getController( "stakeController" );
		};

		luckyBetOnPressed() {
			this.luckyBetOnButton.interactive = false;
			this.luckyBetOffButton.interactive = true;
		
			this.luckyBetOnButton.visible = false;
			this.luckyBetOffButton.visible = true;
		
			let encoreButtonLB = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");    
			encoreButtonLB.onPressedCallback();

			this.stakeText.setText( gdk.formatCurrency( this.stakeController.CurrentStake ) );			
		};

		luckyBetOffPressed() {
			this.luckyBetOnButton.interactive = true;
			this.luckyBetOffButton.interactive = false;
		
			this.luckyBetOnButton.visible = true;
			this.luckyBetOffButton.visible = false;
		
			let encoreButtonLB = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");    
			encoreButtonLB.onPressedCallback();

			this.stakeText.setText( gdk.formatCurrency( this.stakeController.CurrentStake ) );
		};

		onStakeNextPressed() {
			this.stakeController.selectNextStake();
			this.updateButtons();
		};

		onStakePreviousPressed() {
			this.stakeController.selectPreviousStake();
			this.updateButtons();
		};

		showTotalBet( isVisible ) {
			this.visible = isVisible;
			this.updateButtons();

			if ( isVisible && this.platformVisible ) {
				// set correct state of dialog lucky bet button on entry
				let encoreButtonLB = resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton");
				// this.luckyBetOnButton.interactive = encoreButtonLB._flags.showLuckyBetActive && !this.inPromotion && this.platformEnabled;
				// this.luckyBetOffButton.interactive = !encoreButtonLB._flags.showLuckyBetActive && !this.inPromotion && this.platformEnabled;
			// 
				// this.luckyBetOnButton.visible = encoreButtonLB._flags.showLuckyBetActive;
				// this.luckyBetOffButton.visible = !encoreButtonLB._flags.showLuckyBetActive;
// 
				// dim the button if we are in promotion mode/prepaids				
				// this.luckyBetOnButton.alpha = this.inPromotion ? 0.5 : 1;				
				// this.luckyBetOffButton.alpha = this.inPromotion ? 0.5 : 1;
			}
		};

		updateButtons() {
			// update the stake buttons
			this.stakePreviousButton.enableButton( ( this.stakeController.SelectedStakeIndex > 0 ) && !this.inPromotion );
			this.stakeNextButton.enableButton( ( this.stakeController.SelectedStakeIndex < this.stakeController.Stakes.length - 1 ) && !this.inPromotion );

			this.stakeText.setText( gdk.formatCurrency( this.stakeController.CurrentStake ) );
		};

		onPromotionStarted() {
			this.inPromotion = true;
		};

		onPromotionEnded() {
			this.inPromotion = false;
		};
	}
    
    create = function(json) {
        return new SystemTotalBet();
    };
    
    initialise = function(json, container, resources) {
        container.initialise();        
    };
    
    getFilesRequired = function(json) {
        return [ "", "" ];
    };

    resourceManager.registerObjectType("systemTotalBet", create, initialise, getFilesRequired);
}());
